export const partnersObjOne = {
    id: 'services',
    type: 1,
    lightBg: false,
    lightText: true,
    lighTextDesc: true,
    title1: 'Hector Machining',
    title2: 'Jesús Lizárraga',
    title3: 'H&N',
    p1: 'Fabricator',
    p2: 'Ing. Electromecanica',
    p3: 'Distribuidora Industrial',
    Icon1: require('../../img/partners/logo1.png').default,
    Icon2: require('../../img/partners/logo2.png').default,
    Icon3: require('../../img/partners/logo3.png').default,
    alt: 'Icon',
    dark: false,
    primary: true,
    darkText: false
};


